import { GET_PURCHASE_ACCEPTANCE_DATA_API } from "../../constants/api";
import axios from "../fetch/fetch";

export const getPurchaseAcceptanceDataByYearAPI = async (year: number): Promise<any[]> => {
    const response = await axios.get(`${GET_PURCHASE_ACCEPTANCE_DATA_API}/${year}`);
    return response.data;
};
